import styled, {css} from "styled-components";

export interface IStyledLanguageSelectorProps {
	ref?: any;
}

const WrapperMixin = css`
	background-color: ${({theme}) => theme.colors.white};
	color: ${({theme})=> theme.colors.netural800};
	width: 100%;
	max-width: 16rem;
	border: 2px solid ${({theme})=> theme.colors.netural300};
	border-radius: 0.5em;
	padding: 15px;
	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		max-width: 14rem;
		padding: 10px;
	}
`;

export const StyledLanguageSelector = styled.div<IStyledLanguageSelectorProps>`
	font-size: 1.6rem;
	line-height: 2.4rem;
	font-weight: 400;
	max-width: 19.6rem;
	position: relative;
	cursor: pointer;
	font-family: "Inter", sans-serif;
	${WrapperMixin}
`;

export const StyledLanguageSelectorBody = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export interface IStyledLanguageSelectorDropdownProps {
	isOpen: boolean
}

// export const StyledLanguageSelectorDropdown = styled.div<IStyledLanguageSelectorDropdownProps>`
// 	position: absolute;
// 	top: calc(100% + 1em);
// 	left: 0;
// 	right: 0;
// 	display: ${({isOpen})=> isOpen ? 'flex' : 'none'};
// 	flex-direction: column;
// 	gap: 1em;
// 	${WrapperMixin}
// `;

export const StyledLanguageSelectorDropdown = styled.div<IStyledLanguageSelectorDropdownProps>`
	position: absolute;
	top: calc(100% + 1em);
	left: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	gap: 1em;

	overflow: hidden;
	max-height: ${({ isOpen }) => (isOpen ? "500px" : "0")};
	opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
	transform: translateY(${({ isOpen }) => (isOpen ? "0" : "-10px")});
	pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};


	transition:
		max-height 0.3s ease,
		opacity 0.25s ease,
		transform 0.25s ease;

	${WrapperMixin}
`;

export const StyledArrow = styled.img<{ isOpen: boolean }>`
  transition: transform 0.2s ease;
  transform: rotate(${({ isOpen }) => (isOpen ? 180 : 0)}deg);
`;

export const StyledLanguageSelectorItem = styled.div`
	display: flex;
	align-items: center;
	gap: 0.44em;
`;

export const StyledLanguageSelectorDropdownItem = styled.div`
	cursor: pointer;
`;
